import { AppBar, Box, Link, Tab, Tabs, Toolbar, Typography } from '@mui/material';
import LocaleSelector from 'components/LocaleSelector';
import { setupCurrentOriginUrl } from 'utils/contentUtils';

const navigate = (href) => {
  const url = setupCurrentOriginUrl(href);
  if (url != null) {
    window.location.href = url;
  }
};

const TopHeader = ({ topHeaderMenu, topHeaderItems, locales, currentLocale }) => (
  <AppBar component="section" position="relative" color="default" elevation={0} className="bg-body d-none d-lg-flex">
    <Box className="container-fluid g-0" sx={{ '@media (min-width:1680px)': { maxWidth: '1570px' } }}>
      <Toolbar
        variant="dense"
        sx={{
          mx: 'auto',
          width: '100%',
          minHeight: '40px',
          maxHeight: '40px',
          display: 'flex',
          justifyContent: 'space-between',
          paddingLeft: '144px !important',
        }}
      >
        {Array.isArray(topHeaderItems) && topHeaderItems.length > 0 && (
          <Tabs value={0} slotProps={{ indicator: { sx: { display: 'none' } } }} sx={{ minHeight: 'auto' }}>
            {topHeaderItems.map(({ id, label, href }, index) => (
              <Tab
                key={id}
                label={label}
                value={index}
                disableRipple
                onClick={() => navigate(href)}
                sx={{
                  minWidth: 'auto',
                  minHeight: 'auto',
                  px: 0,
                  mr: '1.5rem',
                  '&:last-of-type': { mr: 0 },
                  textTransform: 'none',
                  fontSize: 'inherit',
                  fontWeight: 400,
                  color: 'text.primary',
                  opacity: 1,
                  '&:hover': {
                    color: 'primary.main',
                    textDecoration: 'underline',
                  },
                  '&.Mui-selected': {
                    color: 'primary.main',
                    fontWeight: 600,
                  },
                }}
              />
            ))}
          </Tabs>
        )}
        <div className="d-flex align-items-center justify-content-end gap-4">
          <div className="d-flex align-items-center gap-3">
            {Array.isArray(topHeaderMenu) &&
              topHeaderMenu.map(({ id, label, href }) => {
                const itemUrl = setupCurrentOriginUrl(href);
                return (
                  <Link
                    key={id}
                    href={itemUrl ?? '#'}
                    underline="none"
                    color="text.primary"
                    variant="body2"
                    className="d-none fs-7 d-lg-inline"
                    sx={{
                      textTransform: 'none',
                      ':hover': {
                        textDecoration: 'underline',
                      },
                    }}
                    onClick={itemUrl != null ? undefined : (e) => e.preventDefault()}
                  >
                    <Typography component="span" variant="body2" color="inherit">
                      {label}
                    </Typography>
                  </Link>
                );
              })}
          </div>
          <LocaleSelector locales={locales} currentLocale={currentLocale} />
        </div>
      </Toolbar>
    </Box>
  </AppBar>
);
export default TopHeader;
